import { render, staticRenderFns } from "./SelectRejectReason.vue?vue&type=template&id=0d966993&"
import script from "./SelectRejectReason.vue?vue&type=script&lang=js&"
export * from "./SelectRejectReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports